/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber1 = createReactComponent("outline", "number-1", "IconNumber1", [["path", { "d": "M13 20v-16l-5 5", "key": "svg-0" }]]);

export { IconNumber1 as default };
//# sourceMappingURL=IconNumber1.mjs.map
